<template>
    <u-textarea-outlined-tile v-model="modelValue" v-bind="$attrs" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-textarea-outlined-tile>
</template>

<script>
import UTextareaOutlinedTile from "@/components/publish/styles/forms/u-textarea-outlined-tile.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        UTextareaOutlinedTile,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
